import Vue from 'vue';
import { ElNotificationOptions } from 'element-ui/types/notification';
import { MessageBoxInfo, showAlert, showConfirm, showNotification } from '@/main/utils/notifications';
import { sanitize } from '@/main/utils/html-sanitizer';
import { ElMessageBoxOptions, MessageBoxData } from 'element-ui/types/message-box';
import { LAST_ODOMETER } from '@/main/store/constants';

export interface ErrorAlertMethods {
	showErrorAlert(payload: MessageBoxInfo & { localizeMessage?: boolean }): void

	showConfirmPokracovat(errorCode: string, localize?: boolean, widthByContent?: boolean): boolean

	showConfirmMsg(errorCode: string, localize?: boolean, widthByContent?: boolean, lastStavKm?: any ): boolean

	showConfirm(options: MessageBoxInfo): boolean

	showErrorNotification(message: string): void

	showNotification(message: ElNotificationOptions): void

	prompt(message: string, localize: boolean, options?:ElMessageBoxOptions): Promise<MessageBoxData>;

}

export const ErrorAlertMixin = Vue.extend({
	methods: {
		showErrorAlert(this: Vue, {
			message,
			title = this.Localize('Chyba'),
			options = {
				confirmButtonText: this.Localize('cmdOK'),
			},
			localizeMessage = true,
		}: MessageBoxInfo & { localizeMessage?: boolean }): void {
			// eslint-disable-next-line no-param-reassign
			localizeMessage && (message = message);

			console.warn(message);

			showAlert({ message, title, options });
		},

		showConfirmPokracovat(message: string, localize: boolean = true, widthByContent = false) {
			// eslint-disable-next-line no-param-reassign
			localize && (message = this.LocalizeChyboveHlasky(message));

			// eslint-disable-next-line no-param-reassign
			message = sanitize(`${message}<br>${this.LocalizeChyboveHlasky('Pokrac')}`);

			return this.showConfirm({
				message,
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
					type: 'warning',
					customClass: widthByContent ? 'message-box--max-content-width message-box--top-aligned-icon' : '',
					dangerouslyUseHTMLString: true,
				},
			});
		},
		showConfirmMsg(message: string, localize: boolean = true, widthByContent = false, lastStavKm: number) {
			localize && (message = this.LocalizeChyboveHlasky(message).replace(LAST_ODOMETER, `${lastStavKm}`));
			return this.showConfirm({
				message,
				title: this.LocalizeChyboveHlasky('infoTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
					type: 'info',
					customClass: widthByContent ? 'message-box--max-content-width message-box--top-aligned-icon' : '',
					dangerouslyUseHTMLString: true,
				},
			});
		},

		async showConfirm(this: Vue, {
			message, title = this.Localize('Chyba'), options = {
				confirmButtonText: this.Localize('cmdOK'),
				cancelButtonText: this.Localize('Ne'),
			},
		}: MessageBoxInfo) {
			return showConfirm({ message, title, options });
		},

		showErrorNotification(message: string): void {
			showNotification({ title: this.Localize('Chyba'), message, type: 'error' });
		},

		showNotification,

		prompt(message: string, localize: boolean = true, options?:ElMessageBoxOptions) {
			// eslint-disable-next-line no-param-reassign
			localize && (message = this.Localize(message));
			return this.$prompt(
				message,
				this.LocalizeChyboveHlasky('questionTitle'),
				options ?? {
					confirmButtonText: this.Localize('cmdOK'),
					cancelButtonText: this.Localize('cmdEsc'),
					inputType: 'text',
					inputErrorMessage: this.Localize('InvalidInput'),
				},
			);
		},
	},
});
